import { IObservableArray, makeAutoObservable, observable, runInAction } from 'mobx';

interface NextPageResponseInterface<T> {
    data: T[];
    hasNextPage: boolean;
}

const getRequestHash = (filters: any) => JSON.stringify(filters);

/**
 * Generic store used to fetch paginated data
 * This store needs to be provided with a function to request a page
 */
export class PaginatedDataStore<T, F> {
    pages = observable.map<number, T[]>();
    filters: Partial<F> = observable.object({});

    currentPage: number = 0;
    hasNextPage: boolean = true;
    isLoading: boolean = false;

    get data() {
        return Array.from(this.pages.values()).reduce(
            (previousValue, currentValue) => [...previousValue, ...currentValue],
            []
        );
    }

    constructor(protected loadPage: (page: number, filters: Partial<F>) => Promise<NextPageResponseInterface<T>>) {
        makeAutoObservable(this);
    }

    get isEmpty() {
        return this.data.length === 0 && !this.isLoading;
    }

    reset() {
        console.log('PaginatedDataStore', 'reset');
        this.currentPage = 0;
        this.hasNextPage = true;
        this.pages.clear();
        return this.loadNextPage();
    }

    setFilters(filters: F) {
        console.log('PaginatedDataStore', 'setFilters', filters);

        this.filters = { ...filters };

        return this.reset();
    }

    async loadNextPage() {
        if (!this.hasNextPage) {
            return;
        }

        const hash = getRequestHash(this.filters);

        this.isLoading = true;
        const page = this.currentPage++;
        console.log('PaginatedDataStore', 'loadNextPage', page, this.filters);

        const result = await this.loadPage(this.currentPage, this.filters);

        runInAction(() => {
            console.log('PaginatedDataStore', 'loadNextPage', 'done');

            this.isLoading = false;

            // todo: fixme: hacky way of preventing race condition when filters change
            if (hash === getRequestHash(this.filters)) {
                this.hasNextPage = result.hasNextPage;
                this.pages.set(page, result.data);
            } else {
                console.warn('PaginatedDataStore', 'ignoring request - filters changed');
            }
        });
    }
}
